module.exports = __webpack_public_path__ + "static/img/16-北京第五实验学校1.d04c005.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/16-北京第五实验学校1.png
// module id = upHH
// module chunks = 0